module.exports = __webpack_public_path__ + "img/ss_green-00.7cde2401.jpg";